/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllergyTypeResponseDto } from './allergyTypeResponseDto';
import { NoteDto } from './noteDto';
import { ReactionResponseDto } from './reactionResponseDto';
import { ElementExpandedDto } from './elementExpandedDto';


export interface AllergyResponseDto { 
    /**
     * Allergy identifier
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Element identifier for the allergen
     */
    elementId: string;
    /**
     * Allergy type details (when requested via expand parameter)
     */
    allergyType?: AllergyTypeResponseDto;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Clinical status of the allergy
     */
    status: AllergyResponseDto.StatusEnum;
    /**
     * Element identifier for verification status
     */
    verificationStatusElementId?: string;
    /**
     * Verification status details (when requested via expand parameter)
     */
    verificationStatus?: ElementExpandedDto;
    /**
     * Element identifier for criticality level
     */
    criticalityElementId?: string;
    /**
     * Criticality details (when requested via expand parameter)
     */
    criticality?: ElementExpandedDto;
    /**
     * Reaction details
     */
    reactions?: Array<ReactionResponseDto>;
    /**
     * Onset date/time of the allergy (ISO 8601)
     */
    onsetDateTime?: string;
    /**
     * Date the allergy was recorded (ISO 8601)
     */
    recordedDate: string;
    /**
     * Identifier of the person who recorded the allergy
     */
    recorder?: string;
    /**
     * Identifier of the person who asserted the allergy
     */
    asserter?: string;
    /**
     * Clinical notes about the allergy
     */
    note?: Array<NoteDto>;
    /**
     * Additional metadata for the allergy
     */
    metadata?: any;
    /**
     * Metadata schema definition
     */
    metadataSchema?: any;
    /**
     * Creation timestamp (ISO 8601)
     */
    createdOn: string;
    /**
     * Identifier of the user who created the record
     */
    createdBy: string;
    /**
     * Last modification timestamp (ISO 8601)
     */
    updatedOn?: string;
    /**
     * Identifier of the user who last modified the record
     */
    updatedBy?: string;
}
export namespace AllergyResponseDto {
    export type StatusEnum = 'active' | 'inactive' | 'resolved';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum,
        Resolved: 'resolved' as StatusEnum
    };
}


